/**
 * Run a task when the main thread is idle so it doesn't inflate INP.
 * Falls back to setTimeout(0) where requestIdleCallback is missing.
 * `timeout` caps how long we wait (ms) even if the thread stays busy.
 * Returns a cancel function for effect cleanups.
 */
export function runWhenIdle(task: () => void, timeout = 2000): () => void {
  if (typeof window === 'undefined') return () => {};

  const win = window as Window & {
    requestIdleCallback?: (
      cb: IdleRequestCallback,
      opts?: IdleRequestOptions,
    ) => number;
    cancelIdleCallback?: (id: number) => void;
  };

  if (typeof win.requestIdleCallback === 'function') {
    const id = win.requestIdleCallback(task, { timeout });
    return () => win.cancelIdleCallback?.(id);
  }

  const id = window.setTimeout(task, 0);
  return () => window.clearTimeout(id);
}
